var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonitorDuration = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 6.33333V9L9.66667 10M8 3.33333C4.87038 3.33333 2.33333 5.87038 2.33333 9C2.33333 12.1296 4.87038 14.6667 8 14.6667C11.1296 14.6667 13.6667 12.1296 13.6667 9C13.6667 5.87038 11.1296 3.33333 8 3.33333ZM8 3.33333V1.33333M6.66667 1.33333H9.33333M13.5527 3.728L12.5527 2.728L12.0527 3.228M2.44733 3.728L3.44733 2.728L3.94733 3.228",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgMonitorDuration;